function SkyCom() {
    return (
        <div className="skyBox">
            <div className="sunBox">
                <div className="sun"><div className="sunshine"></div></div>
            </div>
            <div className="cloud1Box">
                <svg version="1.1" id="cloud1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 61.9 21.3" xmlSpace="preserve">
                    <linearGradient id="cloud1Bg" gradientUnits="userSpaceOnUse" x1="30.9468" y1="21.4927" x2="30.9468" y2="1.5597">
                        <stop  offset="0" style={{stopColor:'#E2C083'}}/>
                        <stop  offset="1" style={{stopColor:'#CA6593'}}/>
                    </linearGradient>
                    <path className="cloud1Path" d="M57.5,6.8H51c0.5-0.7,0.9-1.5,0.9-2.4c0-2.1-1.7-3.8-3.8-3.8H13.9c-2.1,0-3.8,1.7-3.8,3.8H4.4
                    c-2.1,0-3.8,1.7-3.8,3.8S2.3,12,4.4,12h15.4c0.2,0.4,0.4,0.8,0.7,1.1c-1.9,0.2-3.3,1.8-3.3,3.7c0,2.1,1.7,3.8,3.8,3.8h17.3
                    c2.1,0,3.8-1.7,3.8-3.8c0-0.9-0.4-1.8-0.9-2.5h16.4c2.1,0,3.8-1.7,3.8-3.8C61.2,8.5,59.6,6.8,57.5,6.8z"/>
                </svg>
            </div>
            <div className="cloud2Box">
                <svg version="1.1" id="cloud2" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 77.1 16.4" xmlSpace="preserve">
                    <linearGradient id="cloud2Bg" gradientUnits="userSpaceOnUse" x1="38.4043" y1="13.7408" x2="38.4043" y2="-5.378054e-02">
                        <stop  offset="0" style={{stopColor:'#E2C083'}}/>
                        <stop  offset="1" style={{stopColor:'#CA6593'}}/>
                    </linearGradient>
                    <path className="cloud2Path" d="M71.5,3.4H42.2c-0.7-1.7-2.4-3-4.4-3H5.3c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7H6c-0.1,0.4-0.2,0.9-0.2,1.3
	                c0,2.6,2.1,4.7,4.7,4.7H32c2,0,3.7-1.3,4.4-3.1h35.1c2.6,0,4.7-2.1,4.7-4.7S74.1,3.4,71.5,3.4z"/>
                </svg>
            </div>
            <div className="cloud3Box">
                <svg version="1.1" id="cloud3" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 37.8 11.6" xmlSpace="preserve">
                    <linearGradient id="cloud3Bg" gradientUnits="userSpaceOnUse" x1="18.9149" y1="10.6148" x2="18.9149" y2="1.1645">
                        <stop  offset="0" style={{stopColor:'#E2D9B1'}}/>
                        <stop  offset="1" style={{stopColor:'#CF8C6E'}}/>
                    </linearGradient>
                    <path className="cloud3Path" d="M34.9,6.5h-8.5c0.2-0.4,0.3-0.8,0.3-1.2h0.6c1.3,0,2.4-1.1,2.4-2.4v0c0-1.3-1.1-2.4-2.4-2.4H11
                    c-1.3,0-2.4,1.1-2.4,2.4H2.9C1.6,2.9,0.6,4,0.6,5.3s1.1,2.4,2.4,2.4h2.9C5.9,9,6.9,10,8.2,10h8.3c0.4,0.7,1.2,1.2,2.1,1.2h16.3
                    c1.3,0,2.4-1.1,2.4-2.4v0C37.3,7.6,36.2,6.5,34.9,6.5z"/>
                </svg>
            </div>
        </div>
    )
}

export default SkyCom;